<div class='form-container'>
  <div mat-dialog-title>
    Order Note Form
  </div>
  <button class="mat-dialog-close" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <div class="note-form">
    <div class="note-form__fields">
      <mat-form-field>
        <!--      <input matInput [multiple]="true" placeholder="Add order note:" [(ngModel)]="note" />-->
        <p class='warning-message'>** This information is for your internal use only and will not be shared with the laboratory. **</p>
        <textarea
          matInput
          placeholder="Add order note:"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          maxlength="300"
          [(ngModel)]="note"
        ></textarea>
        <mat-hint>Maximum of 300 characters</mat-hint>
      </mat-form-field>
    </div>
    <div class="note-form__cta">
      <button class="btn btn-secondary" mat-dialog-close="">Cancel</button>
      <button class="btn btn-primary" (click)="addNote()">Add Note</button>
    </div>
  </div>
</div>
